import { fetch } from '@utils/utils';
import * as T from '@modules/history/_historyTypes';

const getHistoryEvent = ({ addError }) => async (id: string): Promise<T.HistoryEvent | {}> => {
  try {
    const response: any = await fetch(`/metropolis/api/historyEntityDto/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.HistoryEvent = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export { getHistoryEvent };



// WEBPACK FOOTER //
// ./src/modules/history/_historyActions.ts